import { invokeTypes } from "../config/constants";

const debug = process.env.REACT_APP_DEBUG === 'true';

export function getMessageForInvokeType(type) {
  const invokeType = invokeTypes.find(invokeType => invokeType.type === type);
  return invokeType ? invokeType.message : 'Invoking API';
}

export const debugLog = (...message) => debug ? console.log('DEBUG', ...message) : '';